import { Box, Flex, Text } from "@chakra-ui/react";
import { Modal } from "antd";
import FooterModal from "components/Button/FooterModal";
import moment from "moment";
import ListaContas from "./components/ListaContas";
import { FiltroConciliacao } from "./../ModalFiltroConciliacao/hooks/useFiltroConciliacao";
import { useState } from "react";

interface ModalContasNaoConciliadasProps {
  visible: boolean;
  onClose?: () => any;
  data: string;
  filtro?: FiltroConciliacao;
  refetchExtratos?: () => any;
}

export default function ModalContasNaoConciliadas({
  visible,
  onClose,
  data,
  filtro,
  refetchExtratos,
}: ModalContasNaoConciliadasProps) {
  const [liquidacaoCancelada, setLiquidacaoCancelada] = useState(false);

  const _onClose = () => {
    if (liquidacaoCancelada) {
      refetchExtratos?.();
    }

    onClose?.();
  };

  return (
    <>
      <Modal
        centered
        visible={visible}
        footer={
          <FooterModal
            showRegisterAnother={false}
            hidePrimaryButton={true}
            buttonCancelarText="Fechar"
            onClose={_onClose}
          />
        }
        width="1500px"
        onCancel={_onClose}
      >
        <Flex flexDir="column" mb={-8}>
          <Text as="h3" fontSize={20} fontWeight="500" mb="15px">
            Contas não conciliadas {moment(data).format("DD/MM/YYYY")}
          </Text>
          <Box maxH="600px" overflow="auto" className="custom-scroll-bar">
            <ListaContas
              data={data}
              contasBancariasIds={filtro?.contasBancariasIds}
              onLiquidacaoCancelada={() => setLiquidacaoCancelada(true)}
            />
          </Box>
        </Flex>
      </Modal>
    </>
  );
}
